import React, { useEffect, useState } from 'react';
import RegularButton from 'components/CustomButtons/Button';
import { getAllMaterialIcons } from './getAllIcons';
import { Box } from '@mui/material';

const ListIcons = () => {

  const [icons, setIcons] = useState([])
  useEffect(() => {
    setIcons( getAllMaterialIcons() )
  }, [])

  return (
    <Box style={{display: 'flex', flexWrap: 'wrap', gap: 5}}>
    {icons.map((Icon, index) => (
        <RegularButton color="transparent" justIcon key={index} size="sm" tooltip={Icon.displayName}>
          <Icon />
        </RegularButton>
      ))
    }
  </Box>
  )
}


export default React.memo(ListIcons);